import { IconButton, Box as MUIBox, styled, Typography } from '@mui/material'

import { Container } from '../'

export const Content = styled(Container)(({ theme }) => ({
  borderRadius: '8px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  height: '92%',
  maxHeight: '100%',
  overflowY: 'hidden',
  padding: 32,
  width: '92%',

  [theme.breakpoints.down('md')]: {
    maxHeight: '100%',
    width: '100%',
    borderRadius: 0
  }
}))

export const CloseButton = styled(IconButton)(() => ({
  position: 'absolute',
  right: 5,
  top: 5
}))

export const Heading = styled(Typography)`
  align-items: center;
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
`

export const Box = styled(MUIBox)(() => ({
  display: 'flex',
  flexDirection: 'column'
}))

export const Header = styled(MUIBox)(({ theme }) => ({
  alignItems: 'end',
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    width: '100%',
    gap: '0.625rem'
  },
  marginBottom: '12px',
  marginTop: '12px'
}))

export const TableWrapper = styled('div')(({ theme }) => ({
  // sem altura fixa: quem rola é o ModalContent (mesmo comportamento da aba
  // Saldo). Em pais flex-column (RequestAntecipation) o flex:1 preenche o
  // espaço disponível.
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  '& tr:hover': {
    cursor: 'pointer',
    background: theme.palette.neutral[800]
  }
}))

type ItemWrapperProps = {
  type: 'Receivable' | 'Expense'
}

export const ItemWrapper = styled('div')<ItemWrapperProps>(
  ({ type, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background:
      type === 'Receivable'
        ? theme.palette.primary[200]
        : theme.palette.error[300],
    width: 20,
    height: 20,
    borderRadius: 100,
    margin: 0,
    padding: 0
  })
)

export const Item = styled('div')(() => ({
  color: '#FFF',
  font: 'normal 600 16px Inter, sans-serif',
  margin: 0,
  marginBottom: 2,
  padding: 0
}))

export const EmptyStateWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%'
}))
